import studyService from '../services/studyService';

class StudyUtil {
  constructor() {
    this.cachedStudyCount = null;
    this.cacheExpiry = null;
    this.CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds
  }

  /**
   * Get the number of studies the current user has access to
   * Uses caching to avoid repeated API calls
   */
  async getUserStudyCount() {
    // Check if we have a valid cached result
    if (this.cachedStudyCount !== null && 
        this.cacheExpiry && 
        Date.now() < this.cacheExpiry) {
      console.debug('[STUDY_UTIL] Using cached study count:', this.cachedStudyCount);
      return this.cachedStudyCount;
    }

    try {
      console.debug('[STUDY_UTIL] Fetching fresh study count...');
      const response = await studyService.getStudies();
      const studiesData = Array.isArray(response) ? response : [];
      const filteredStudies = studiesData.filter(study => study && study.id);
      
      console.debug('[STUDY_UTIL] Raw studies data:', studiesData);
      console.debug('[STUDY_UTIL] Filtered studies:', filteredStudies);
      
      // Cache the result
      this.cachedStudyCount = filteredStudies.length;
      this.cacheExpiry = Date.now() + this.CACHE_DURATION;
      
      console.debug('[STUDY_UTIL] Final study count:', this.cachedStudyCount);
      return this.cachedStudyCount;
    } catch (error) {
      console.error('Error fetching study count:', error);
      return 0;
    }
  }

  /**
   * Check if the user has access to only one study
   */
  async hasOnlyOneStudy() {
    const studyCount = await this.getUserStudyCount();
    return studyCount === 1;
  }

  /**
   * Clear the cached study count (useful after user changes or study modifications)
   */
  clearCache() {
    this.cachedStudyCount = null;
    this.cacheExpiry = null;
  }
}

// Export a singleton instance
const studyUtil = new StudyUtil();
export default studyUtil;
